import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5;

import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H4 } from 'UIComponents/elements/headings';
import UIImage from 'UIComponents/image/UIImage';
import BestValueBadge from '../common/BestValueBadge';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons'; // @ts-expect-error svg import

import BLOB from 'bender-url!pricing-pages-ui/img/splash-page/suite-card-top-right-blob.svg';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { useAppSelector } from '../../reducers';
import { STARTER_SUITE_CARD_CBX003 } from '../../constants/tracking/Locations';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { CrmSuitePrice } from '../merch-card/price-display/CrmSuitePrice';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { useValidatedCrmSuiteQueryParamTerm } from '../../utils/urls/queryParamUtils';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SuiteTermSelectorContainer from '../merch-card/SuiteTermSelectorContainer';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { ProductLineIcon, IconImage } from '../splash-page/SplashPageSharedComponents';
import Small from 'UIComponents/elements/Small';
import SuiteTileCTAsContainer from '../merch-card/SuiteTileCTAsContainer';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import Screens from '../../constants/routing/Screens';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { LearnMoreModal } from './LearnMoreModal';
import { useState } from 'react';
import { NEW_CUSTOMER_OFFER } from '../../constants/pricing/DiscountedKeys';
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { getHighlightsForProductLine, getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "StarterCrmSuiteCardCBX003__StyledCardWrapper",
  componentId: "sc-1oftvme-0"
})(["display:flex;width:100%;padding:32px 24px;border:2px solid ", ";min-height:150px;text-align:left;margin:auto;position:relative;overflow:hidden;", ";", ";"], CALYPSO_MEDIUM, breakpoint.tablet(_t || (_t = _`
    min-width: 0;
    &&& {
      margin: 0 auto;
    }

  `)), breakpoint.tabletPortrait(_t2 || (_t2 = _`
    width: 94%;
  `)));
const StyledBlob = styled(UIImage).withConfig({
  displayName: "StarterCrmSuiteCardCBX003__StyledBlob",
  componentId: "sc-1oftvme-1"
})(["position:absolute;top:-1px;right:-1px;"]);
const StyledBestValueBadge = styled(BestValueBadge).withConfig({
  displayName: "StarterCrmSuiteCardCBX003__StyledBestValueBadge",
  componentId: "sc-1oftvme-2"
})(["position:absolute;z-index:1;top:12px;right:12px;"]);
const CardHeader = styled.div.withConfig({
  displayName: "StarterCrmSuiteCardCBX003__CardHeader",
  componentId: "sc-1oftvme-3"
})(["z-index:2;justify-content:center;align-self:center;margin-bottom:24px;"]);
const ContentContainer = styled.div.withConfig({
  displayName: "StarterCrmSuiteCardCBX003__ContentContainer",
  componentId: "sc-1oftvme-4"
})(["display:flex;flex-direction:column;justify-content:space-between;align-self:flex-start;max-width:600px;", ""], breakpoint.phoneLarge(_t3 || (_t3 = _`
    margin-top: 32px;
  `)));
const CTAsContainer = styled.div.withConfig({
  displayName: "StarterCrmSuiteCardCBX003__CTAsContainer",
  componentId: "sc-1oftvme-5"
})(["align-self:flex-start;display:flex;flex-direction:column;justify-content:center;align-items:stretch;height:100%;max-width:350px;width:100%;z-index:2;button,a{width:100%;line-height:25px;}div:first-child{margin-top:0 !important;}", " ", ""], breakpoint.tablet(_t4 || (_t4 = _`
    justify-content: flex-start;
    margin-top: 32px;
  `)), breakpoint.phoneLarge(_t5 || (_t5 = _`
    max-width: 100%;
    margin-top: 16px;
  `)));
const DisclaimerContainer = styled(Small).withConfig({
  displayName: "StarterCrmSuiteCardCBX003__DisclaimerContainer",
  componentId: "sc-1oftvme-6"
})(["align-self:flex-start;margin-top:16px;max-width:300px;"]);

const StarterCrmSuiteCardCBX003 = ({
  containerStyle,
  screen = Screens.MARKETING
}) => {
  const {
    queryParamTerm,
    setQueryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel: STARTER
  }); // Learn more modal

  const [isLearnMoreModalOpen, setIsLearnMoreModalOpen] = useState(false);
  const productLevels = getMerchCardsToShow({
    isSuiteStarterPage: true
  });
  const marketingHighlightedProducts = getHighlightsForProductLine(ProductLines.MARKETING);
  const filteredMarketingHighlightedProducts = marketingHighlightedProducts.filter(apiName => {
    const localProductLevel = getProductLevelFromApiNameString(apiName);
    return productLevels.includes(localProductLevel);
  });
  const salesHighlightedProducts = getHighlightsForProductLine(ProductLines.SALES);
  const filteredSalesHighlightedProducts = salesHighlightedProducts.filter(apiName => {
    const localProductLevel = getProductLevelFromApiNameString(apiName);
    return productLevels.includes(localProductLevel);
  });
  const serviceHighlightedProducts = getHighlightsForProductLine(ProductLines.SERVICE);
  const filteredServiceHighlightedProducts = serviceHighlightedProducts.filter(apiName => {
    const localProductLevel = getProductLevelFromApiNameString(apiName);
    return productLevels.includes(localProductLevel);
  });
  const operationsHighlightedProducts = getHighlightsForProductLine(ProductLines.OPERATIONS);
  const filteredOperationsHighlightedProducts = operationsHighlightedProducts.filter(apiName => {
    const localProductLevel = getProductLevelFromApiNameString(apiName);
    return productLevels.includes(localProductLevel);
  });
  const cmsHighlightedProducts = getHighlightsForProductLine(ProductLines.CMS);
  const filteredCmsHighlightedProducts = cmsHighlightedProducts.filter(apiName => {
    const localProductLevel = getProductLevelFromApiNameString(apiName);
    return productLevels.includes(localProductLevel);
  });
  const productsByProductLine = {
    [ProductLines.MARKETING]: filteredMarketingHighlightedProducts,
    [ProductLines.SALES]: filteredSalesHighlightedProducts,
    [ProductLines.SERVICE]: filteredServiceHighlightedProducts,
    [ProductLines.OPERATIONS]: filteredOperationsHighlightedProducts,
    [ProductLines.CMS]: filteredCmsHighlightedProducts
  };
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const productLineChecklist = AllProductLines.map(key => {
    return /*#__PURE__*/_jsxs(ProductLineIcon, {
      className: "m-y-1",
      children: [/*#__PURE__*/_jsx(IconImage, {
        className: "display-inline m-right-3 m-top-1",
        src: ProductLinePageIcons[key],
        style: {
          height: '18px'
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `CBX003.starterSuiteGWPCard.includes.${key}`
      })]
    }, key);
  });

  const StarterContent = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "CBX003.starterSuiteGWPCard.description"
    }), /*#__PURE__*/_jsx("span", {
      className: "m-top-4 m-bottom-1",
      style: {
        fontSize: '1.125em',
        fontWeight: 600
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `CBX003.starterSuiteGWPCard.includes.title`
      })
    }), productLineChecklist]
  });

  const onClickLearnMore = () => {
    setIsLearnMoreModalOpen(!isLearnMoreModalOpen);
    getUsageTracker().track('clickToViewModal', {
      name: 'starter-crm-suite-learn-more-modal',
      screen,
      trackingSource: STARTER_SUITE_CARD_CBX003
    });
  };

  const LearnMoreLink = () => /*#__PURE__*/_jsx("div", {
    className: "align-cente justify-center m-top-4",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        UILink
      },
      message: "CBX003.starterSuiteGWPCard.learnMoreLink_jsx",
      options: {
        onClick: () => onClickLearnMore()
      }
    })
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isLearnMoreModalOpen && /*#__PURE__*/_jsx(LearnMoreModal, {
      productsByProductLine: productsByProductLine,
      setIsLearnMoreModalOpen: setIsLearnMoreModalOpen,
      screen: screen
    }), /*#__PURE__*/_jsxs(StyledCardWrapper, {
      style: containerStyle,
      className: "m-top-5",
      children: [/*#__PURE__*/_jsx(StyledBlob, {
        src: BLOB
      }), /*#__PURE__*/_jsx(StyledBestValueBadge, {
        message: "newCustomerOffer"
      }), /*#__PURE__*/_jsxs(CardHeader, {
        children: [/*#__PURE__*/_jsx(H4, {
          className: "justify-center m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CBX003.starterSuiteGWPCard.title"
          })
        }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "CBX003.starterSuiteGWPCard.subtitle_jsx",
          elements: {
            b: 'b'
          },
          options: {
            hubName: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `pricingPage.products.${screen.toUpperCase()}.STARTER`
            })
          }
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-row justify-between",
        children: [/*#__PURE__*/_jsx(ContentContainer, {
          children: /*#__PURE__*/_jsx(StarterContent, {})
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex-column justify-between",
          children: [/*#__PURE__*/_jsxs(CTAsContainer, {
            children: [/*#__PURE__*/_jsx(SkeletonLoadWrapper, {
              isLoading: !hasPricingAndPurchasingSucceeded,
              heights: [16, 23, 16],
              widths: [60, 70, 130],
              className: "flex-column align-end",
              Content: CrmSuitePrice,
              contentProps: {
                productLevel: STARTER,
                termOverride: queryParamTerm,
                useDiscountedKey: NEW_CUSTOMER_OFFER
              }
            }), /*#__PURE__*/_jsx("div", {
              className: "m-y-3",
              children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
                isLoading: !hasPricingAndPurchasingSucceeded,
                heights: [41],
                Content: SuiteTermSelectorContainer,
                contentProps: {
                  productLevel: STARTER,
                  onChange: newTerm => {
                    setQueryParamTerm(newTerm);
                  },
                  queryParamTerm,
                  trackingSource: STARTER_SUITE_CARD_CBX003,
                  isStarterSuiteGWP: true
                }
              })
            }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
              isLoading: !hasPricingAndPurchasingSucceeded,
              heights: [47],
              children: /*#__PURE__*/_jsx(SuiteTileCTAsContainer, {
                productLevel: STARTER,
                trackingSource: STARTER_SUITE_CARD_CBX003,
                sourceId: `pricing-${screen}-page-starter-suite-card`,
                hubsSignupProductOverride: "suitestarter",
                isStarterGWPCard: true,
                ctaStyles: {
                  marginTop: '4px'
                }
              })
            })]
          }), /*#__PURE__*/_jsx(LearnMoreLink, {}), /*#__PURE__*/_jsx(DisclaimerContainer, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.promotions.starterGWPDisclaimer"
            })
          })]
        })]
      })]
    })]
  });
};

export default StarterCrmSuiteCardCBX003;